import { render, staticRenderFns } from "./ProductFormPage.vue?vue&type=template&id=3e3fe30c&scoped=true&"
import script from "./ProductFormPage.vue?vue&type=script&lang=js&"
export * from "./ProductFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3fe30c",
  null
  
)

export default component.exports